import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type CTAButtonProps = {
  label: string;
  id?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  label,
  id,
  className = '',
  size = 'lg'
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-5 text-[17px] sm:px-8 sm:text-lg md:text-xl' : 'px-5 py-4 text-base';
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta ${sizing} text-center font-display font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#15803d] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#2bd46a] active:translate-y-[4px] active:shadow-[0_2px_0_0_#15803d] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${className}`} data-id="element-121" data-mp="2tyb6ss8em8l8">
      <span data-id="element-122" data-mp="38q3ld20djilw">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-123" data-mp="38mfts8ehp69t" />
    </a>;
}